import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { CartStorage } from 'src/app/appStorage/cart.storage';

@Component({
  selector: 'app-user-inactivity',
  templateUrl: './user-inactivity.component.html',
  styleUrls: ['./user-inactivity.component.scss'],
  standalone: false,
})
export class UserInactivityComponent implements OnInit {

  totalCount:number = 15;
  count:number = this.totalCount;
  countdownInterval: any;


  constructor(
    private modalCtrl: ModalController,
    private cartStorage: CartStorage,
    private navCtrl: NavController,
  ) {
    
   }


  ngOnInit() {
    this.startCountdown();
  }

  closeModal(action?:string) {
    this.modalCtrl.dismiss(action || 'closed');
  }

  goToHome() {
    this.closeModal();
    this.navCtrl.navigateBack('/home');
    this.cartStorage.clearCart();
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.count > 0) {
        this.count--;
      } else {
        clearInterval(this.countdownInterval);
        this.cartStorage.clearCart();
        this.goToHome()
      }
    }, 1000);
  }


  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
  
}